import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { McpServerSummary } from '../../types/team.js';

@customElement('cp-mcp-server-card')
export class CpMcpServerCard extends LitElement {
  @property({ type: Object }) server!: McpServerSummary;

  override render() {
    return html`
      <div class="mcp-server-card">
        <div class="mcp-server-card__header">
          <h3 class="mcp-server-card__name">${this.server.name}</h3>
          <span class="mcp-server-card__type-badge">${this.server.type}</span>
        </div>
        <div class="mcp-server-card__info">
          <span class="mcp-server-card__command">${this.server.command}</span>
          ${this.server.args.length > 0 ? html`
            <span class="mcp-server-card__args">${this.server.args.join(' ')}</span>
          ` : nothing}
        </div>
      </div>
    `;
  }

  createRenderRoot() { return this; }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-mcp-server-card': CpMcpServerCard;
  }
}
